import React from "react";
import { useParams } from "react-router-dom";

const CategoryPage = () => {
  const { categorySlug } = useParams();
  return null;
};

export default CategoryPage;
